export interface PostSpaceSummary {
  events_overview?: string;
  overview?: string;
  relevant_posts?: Array<{
    title: string;
    url: string;
    reference_number: number;
  }>;
  topics?: Array<{
    topic_name: string;
    summary: string;
    summary_subcategories_by_author?: string[];
    relevant_posts?: Array<{
      title: string;
      url: string;
      reference_number: number;
    }>;
  }>;
  total_records?: number;
}

export const SPACE_DATE_RANGE = {
  LAST_7_DAYS: "last_7_days",
  LAST_MONTH: "last_month",
  FROM_UNREAD: "from_unread",
} as const;

export type SpaceDateRange =
  (typeof SPACE_DATE_RANGE)[keyof typeof SPACE_DATE_RANGE];
